import { useCallback } from "react";
import { useSearchParams } from "react-router";
import { VENDOR_PARAMS } from "~/utils/vendor";

/**
 * Reads and writes the `postalCode` URL search param.
 * Shared between VendorFilter (write) and PharmacyMap (read).
 *
 * Returns `null` when no postal code is in the URL. Consumers should
 * handle this state appropriately (e.g., show a placeholder map).
 */
export function usePostalCodeParam() {
	const [searchParams, setSearchParams] = useSearchParams();
	const postalCode = searchParams.get(VENDOR_PARAMS.postalCode);

	const setPostalCode = useCallback(
		(value: string) => {
			setSearchParams(
				(prev) => {
					if (value) {
						prev.set(VENDOR_PARAMS.postalCode, value);
					} else {
						prev.delete(VENDOR_PARAMS.postalCode);
					}
					return prev;
				},
				{ replace: true },
			);
		},
		[setSearchParams],
	);

	return { postalCode, setPostalCode };
}
